export interface SignupData {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    hasSignupCompleted: boolean;
    plan?: LicenseType;
    planIsYearly: boolean
}

export enum LicenseType {
    INDIVIDUAL = 'individual',
    GROUP = 'group',
    ENTERPRISE = 'enterprise'
}
